import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect, useRef } from "react";

export default function Hero() {
  const videos = [
    "/videos/2.mp4",
    "/videos/3.mp4",
    "/videos/4.mp4",
  ];

  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const videoRef = useRef();

  const texts = ["موبي كاشير", "إدارة الفواتير", "تحليل المبيعات"];
  const [index, setIndex] = useState(0);


  useEffect(() => {
    const textInterval = setInterval(() => {
      setIndex((prev) => (prev + 1) % texts.length);
    }, 2000);
    return () => clearInterval(textInterval);
  } );


  const handleVideoEnd = () => {
    setCurrentVideoIndex((prev) => (prev + 1) % videos.length);
  };

  return (
    <section
      id="home"
      className="relative h-screen flex items-center justify-center overflow-hidden"
    >

      <AnimatePresence mode="wait">
        <motion.video
          key={currentVideoIndex}
          ref={videoRef}
          autoPlay
          muted
          playsInline
          onEnded={handleVideoEnd}
          className="absolute inset-0 w-full h-full object-cover z-0"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
        >
          <source src={videos[currentVideoIndex]} type="video/mp4" />
        </motion.video>
      </AnimatePresence>


      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-blue-900/40 to-black/60 z-10"></div>


      <motion.div
        dir="rtl"
        className="relative z-20 text-center text-white px-4 max-w-3xl mx-auto backdrop-blur-2xl bg-white/10 border border-white/10 rounded-2xl p-8 shadow-2xl"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >

        <motion.h1
          className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-6 tracking-tight leading-tight text-white"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <AnimatePresence mode="wait">
            {index === 0 ? (
              <motion.span
                key="welcome"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.6 }}
              >
                <span className="text-white">مرحباً بك في </span>
                <span className="text-yellow-400">موبي كاشير</span>
              </motion.span>
            ) : (
              <motion.span
                key={`feature-${index}`}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.6 }}
                className="inline-block"
              >
                <span className="text-yellow-400">موبي كاشير</span>
                <span className="text-white"> يختص في </span>
                <motion.span
                  key={texts[index]}
                  initial={{ opacity: 0, x: 10 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -10 }}
                  transition={{ duration: 0.4 }}
                  className="inline-block text-white"
                >
                  {texts[index]}
                </motion.span>
              </motion.span>
            )}
          </AnimatePresence>
        </motion.h1>



        <motion.p
          className="text-lg md:text-xl mb-6 max-w-2xl mx-auto text-gray-200"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 1 }}
        >
          نقدم حلول برمجية متخصصة في مجال المحاسبة تلبي احتياجات الشركات بمختلف أحجامها وتساعدها في إدارة الحسابات بكفاءة ودقة.
        </motion.p>


        <motion.a
          href="#services"
          className="inline-block bg-yellow-400 text-b
          lue-900 px-8 py-4 rounded-full shadow-lg hover:bg-yellow-300 hover:shadow-xl transition-all duration-300 text-lg font-semibold"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          استكشف الخدمات
        </motion.a>



        <p className="text-sm mt-4 text-gray-300">
          معتمد من <span className="text-yellow-400 font-bold">هيئة الزكاة والضريبة والجمارك</span> كمزود حلول فواتير إلكترونية.
        </p>
      </motion.div>
    </section>
  );
}
